import React from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { Flex } from 'ui/acro'
import DrawerSectionHeader from './common/DrawerSectionHeader'
import DrawerResultTitleText from './common/DrawerResultTitleText'
import DrawerResultSubtitleText from './common/DrawerResultSubtitleText'
import { CircleImage } from './common'
import CommonLink from 'components_v2/CommonLink'

const FlexWrap = styled(Flex)`
  ${css({
    flexWrap: 'wrap',
    width: '100%',
    gap: ['1em', '1em', '1em', '0']
  })}
`
const FlexBox = styled(Flex)`
  ${css({
    alignItems: 'center',
    flexDirection: ['row', 'row', 'row', 'column'],
    flex: [null, null, null, '1'],
    width: '100%',
    maxWidth: ['none', 'none', 'none', 'calc(100% / 3)']
  })}
`

const InstructorResultItems = ({ data, value }) => {
  const instructorData = data && data.instructors.top
  const count = data && data.instructors.resultCount

  if (instructorData && instructorData.length) {
    return (
      <FlexWrap>
        <DrawerSectionHeader
          title={'Instructors'}
          to={`/search?q=${value}&tab=instructors`}
          count={count}
          as={CommonLink}
          padding={'0 0 1em 0'}
          display={['none', 'none', 'none', 'flex']}
        />
        {instructorData.slice(0, 3).map((item, idx) => (
          <FlexBox
            key={idx}
            id={'DrawerResultsInstructor' + (idx + 1)} // +1 so we don't start with position 0
            as={CommonLink}
            className='unstyled'
            to={item.url}
            cursor='pointer'
            onMouseDown={
              // Prevent onMouseDown event because onBlur is called on-mouse-down whereas click handler is on-mouse-up
              (e) => e.preventDefault()
            }
          >
            <CircleImage
              src={
                item.thumbnailImage === null
                  ? 'https://d28gwrkukqy4h7.cloudfront.net/users/ico-profile-default.png'
                  : item.thumbnailImage
              }
            />
            <Flex flexDirection='column'>
              {item.name && (
                <DrawerResultTitleText
                  id='InstructorTitle'
                  textAlign='center'
                  pt='.5em'
                  margin={[null, null, null, '2px 10px !important']}
                >
                  {item.name}
                </DrawerResultTitleText>
              )}
              <DrawerResultSubtitleText
                display={['flex', 'flex', 'flex', 'none']}
              >
                Instructor
              </DrawerResultSubtitleText>
            </Flex>
          </FlexBox>
        ))}
      </FlexWrap>
    )
  } else {
    return <></>
  }
}

export default InstructorResultItems
